<script>
import { mergeData } from 'vue-functional-data-merge'
import { QBtn, QTooltip } from 'quasar' // , Screen
import _ from 'lodash'

// https://quasar.dev/vue-components/tooltip#Positioning
const tooltips = {
  top: {
    anchor: 'top middle',
    self: 'bottom middle',
    offset: [10, 10]
  },
  right: {
    anchor: 'center right',
    self: 'center left',
    offset: [10, 10]
  },
  bottom: {
    anchor: 'bottom middle',
    self: 'top middle',
    offset: [10, 10]
  },
  left: {
    anchor: 'center left',
    self: 'center right',
    offset: [10, 10]
  },
  start: {
    anchor: 'center start',
    self: 'center end',
    offset: [10, 10]
  },
  end: {
    anchor: 'center end',
    self: 'center start',
    offset: [10, 10]
  }
}
export default {
  functional: true,
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    outline: {
      type: Boolean,
      default: null
    },
    glossy: {
      type: Boolean,
      default: true
    },
    push: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: null
    },
    tooltipText: String,
    tooltipPosition: {
      type: String,
      default: 'bottom',
      validator (val) {
        return val in tooltips
      }
    }
  },
  render (createElement, { props, data, children }) {
    if (props.tooltipText) {
      const tooltipElement = createElement(QTooltip, {
        props: Object.assign({
          value: (props.disable || data.attrs?.disable) ? false : null
        }, tooltips[props.tooltipPosition]),
        scopedSlots: {
          default () {
            return props.tooltipText
          }
        }
      })
      children = children ? [...children, tooltipElement] : [tooltipElement]
    }
    return createElement(QBtn, mergeData({
      props: {
        ..._.omit(props, ['tooltipText', 'tooltipPosition', 'dense']),
        dense: props.dense // _.isNil(props.dense) && Screen.lt.lg ? false : props.dense
      }
    }, data), children)
  }
}
</script>
